"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
var React = require("react");
var common_1 = require("docs/common");
exports.PropertiesAppBar = function () { return (React.createElement(common_1.PropertyTable, null,
    React.createElement(common_1.Property, { name: "title", type: "string", description: "Title displayed in app bar." }),
    React.createElement(common_1.Property, { name: "hideToggleDrawerIconButton", type: "bool", defaultValue: "false", description: "Hide default button." }),
    React.createElement(common_1.Property, { name: "toggleDrawerIconColor", type: "string", description: "Color of default button. Can be a string, rgb, hex or hsl value." }),
    React.createElement(common_1.Property, { name: "onToggleDrawerClick", type: "function", description: "A function that will be triggered when the default button is clicked." }))); };
exports.PropertiesAppBar.displayName = 'PropertiesAppBar';



//////////////////
// WEBPACK FOOTER
// ./src/docs/pages/ComponentAppBarPage/PropertiesAppBar.tsx
// module id = 628
// module chunks = 0